import { render } from "./RulesForRoleView.vue?vue&type=template&id=f213fafe&ts=true"
import script from "./RulesForRoleView.vue?vue&type=script&lang=ts"
export * from "./RulesForRoleView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__